import axios from "axios";
import { API } from "../config";
import { hasAnalyticsConsent } from "./consent";

export function track(event, props = {}) {
  if (!hasAnalyticsConsent()) return;

  try {
    axios.post(`${API}/analytics/event`, { event, props }, {
      headers: { "X-Analytics-Consent": "granted" },
    }).catch(() => {});
    if (window.__humnAnalytics) window.__humnAnalytics(event, props);
  } catch (e) {}
}
